import { ChildContext } from '@components/PageStructure/types';

const translationDefaults = {
  DROPDOWN_PLACEHOLDER: '- Select -',
  DROPDOWN_LOADING_OPTIONS: 'Loading...',
  DROPDOWN_NO_OPTIONS: 'No options'
};

export function translationGetter(
  context: ChildContext,
  translationKey: keyof typeof translationDefaults
) {
  if (context && context.translations && context.translations[translationKey]) {
    return context.translations[translationKey];
  }

  return translationDefaults[translationKey];
}
